import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardPendingEnrolment } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'
import { NAV_PATHS } from '../navigation/paths.ts'

// The screen a family reaches while the club reviews the enrolment. Its guard asks for the
// request itself: here `/v1/me` answers 403 `account-not-linked`, the normal case.
export const familyEnrolmentStatusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.familyEnrolmentStatus,
  staticData: { chrome: 'bare' },
  beforeLoad: ({ context, location }) =>
    guardPendingEnrolment({ queryClient: context.queryClient, currentPath: location.href }),
  component: lazyRouteComponent(() => import('../pages/family-enrolment-status.tsx')),
})
